import Promise from 'bluebird'

import utils from 'src/utils/utils'
import eventBus from 'src/lib/eventBus'

class ModalResult {
  constructor(id, promise, modalOptions) {
    if (!id) throw new Error('id')
    if (!promise) throw new Error('promise')
    if (!modalOptions) throw new Error('modalOptions')

    this._id = id
    this._promise = promise
    this._modalOptions = modalOptions
  }

  get promise() {
    return this._promise
  }

  /**
   * @param {Object} [panel]
   * @param {Object} [panel.props] - any props you want to update
   */
  show(panel = {}) {
    const modalOptions = Object.assign(this._modalOptions, panel)

    return showModal(modalOptions, this._id)
  }

  hide() {
    const modalOptions = Object.assign(
      {
        id: this._id,
      },
      this._modalOptions
    )

    eventBus.$emit('hideVueModal', modalOptions)
  }
}

function showModal(modalOptions) {
  if (!modalOptions) throw new Error('modalOptions is required')
  if (!modalOptions.component) throw new Error('modalOptions.component is required')

  modalOptions.id = utils.generateGuid()

  const promise = new Promise((resolve) => {
    eventBus.$emit('showVueModal', modalOptions)

    eventBus.$once(`hideVueModal-${modalOptions.id}`, (payload) => {
      return resolve(payload.data)
    })
  })

  return new ModalResult(modalOptions.id, promise, modalOptions)
}

export default {
  showModal,
}



// WEBPACK FOOTER //
// ./src/lib/vueModals.js